import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoPico } from '@shared/enums/tipoPico';
import { Pico } from '@shared/models/despacho/Pico';

@Component({
  selector: 'app-visor-picos',
  templateUrl: './visor-picos.component.html',
  styleUrls: ['./visor-picos.component.css']
})
export class VisorPicosComponent {

  @Input() nombreContenedor: string;
  @Input() picos: Pico[];

  constructor(public activeModal: NgbActiveModal) { }

  obtenerNombrePico(tipo: number){
    return TipoPico[tipo];
  }

}
